module.exports = __webpack_public_path__ + "img/compliance--icon.558b5fb6.svg";